exports.groups = {
    router: {
        label: 'Router core',
        files: [
            'src/utils/__tests__/strange-router-v3-shim.spec.js',
            'src/utils/__tests__/Routes.behavior.spec.js',
            'src/utils/__tests__/withPropTypeDependencies.spec.js',
            'src/utils/__tests__/RouteDependencyError.spec.js'
        ]
    },
    routeMetadata: {
        label: 'Route metadata',
        files: [
            'src/routes/app/__tests__/route-audit.spec.js',
            'src/routes/app/__tests__/route-permissions.spec.js',
            'src/routes/app/__tests__/route-test-script.spec.js',
            'src/routes/app/__tests__/dependency-module-purity.spec.js'
        ]
    },
    dependencies: {
        label: 'Route dependency contracts',
        files: [
            'src/routes/app/classes/containers/__tests__/ClassChatFrame.dependencies.spec.js',
            'src/routes/app/classes/containers/__tests__/announcement-chat-dependencies.spec.js',
            'src/routes/app/containers/Chat/__tests__/direct-message-dependencies.spec.js',
            'src/routes/app/admin/__tests__/dashboard-dependencies.spec.js',
            'src/routes/app/admin/__tests__/dashboard-school-access.spec.js',
            'src/routes/app/profile/__tests__/profile-dependencies.spec.js'
        ]
    }
};

exports.allFiles = Object.values(exports.groups)
    .reduce((collector, group) => collector.concat(group.files), []);

if (
    typeof describe === 'function'
    && typeof expect === 'function'
    && typeof expect.getState === 'function'
    && expect.getState().testPath
    && expect.getState().testPath.endsWith('route-test-groups.js')
) {
    describe('route test groups', () => {

        it('defines focused route-system test files', () => {

            expect(exports.allFiles.length).toBeGreaterThan(0);
        });
    });
}
